<!-- 文件中文名: 经销商注册 -->
<template>
    <div class="in-register app-container">
        <app-breadcrumb/>
        <div class="page-container recharge-manage">
            <div v-show="step===1">
                <el-form ref="oneRef" :rules="oneRules" :model="oneInfo" label-width="160px" size="mini">
                    <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
                    <!-- 推荐人编号 -->
                    <el-form-item :label="$t('mi.recommendNo')+ ':'" prop="recommendNo">
                        <el-input v-model.trim="oneInfo.recommendNo" clearable style="width: 300px"
                                  @blur.native.capture="recommendNoBlur($event.target.value)"/>
                        <span :class="colorSpan0">&nbsp;&nbsp;&nbsp;&nbsp;{{recommendName}}</span>
                    </el-form-item>
                    <!-- 安置人编号 -->
                    <el-form-item :label="$t('mi.linkNo')+ ':'" prop="tmpLinkNo">
                        <el-input v-model.trim="oneInfo.tmpLinkNo" clearable style="width: 300px"
                                  @blur.native.capture="tmpLinkNoBlur($event.target.value)"/>
                        <span :class="colorSpan1">&nbsp;&nbsp;&nbsp;&nbsp;{{ tmpLinkNo }}</span>
                    </el-form-item>
                    <!-- 代办处编号 -->
                    <el-form-item :label="$t('miAgent.agentNo')+ ':'" prop="agentNo">
                        <el-input v-model.trim="oneInfo.agentNo" style="width: 300px"
                                  @blur.native.capture="agentBlur($event.target.value)"/>
                        <span :class="colorSpan2">&nbsp;&nbsp;&nbsp;&nbsp;{{ agentNo }}</span>
                    </el-form-item>
                </el-form>
                <div style="text-align: center; margin: 10px 0">
                    <el-button type="primary" :loading="doLoading" @click="nextBtn">{{ $t('button.next') }}</el-button>
                    <el-button icon="el-icon-close" @click="onBack">{{ $t('operation.button.cancel') }}</el-button>
                </div>
            </div>
            <div v-show="step===2">
                <el-form ref="twoRef" :rules="twoRules" :model="twoInfo" label-width="160px" size="mini">
                    <div class="pane-title">{{ $t('Common.basicInfomation') }}</div>
                    <el-divider/>
                    <!-- 经销商编号 -->
                    <el-form-item :label="$t('miMember.memberNo')+ ':'" >
                        {{ oneInfo.memberNo }}
                    </el-form-item>
                    <!-- 经销商姓名 -->
                    <el-form-item :label="$t('miMember.name')+ ':'" prop="name">
                        <el-input v-model="twoInfo.name" clearable @blur="nameBlur($event)"  style="width: 300px"/>
                    </el-form-item>
                    <!-- 分公司编码 -->
                    <el-form-item   :label="$t('fiAwardTemp.companyCode')+ ':'" prop="companyCode">
                        <el-select v-model="twoInfo.companyCode" clearable style="width:300px;">
                            <el-option v-for="item in companyCodeList" :key="item.code" :label="$t(item.title)" :value="item.code" >
                                <span style="float: left">{{ item.code }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.title }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 证件类型 -->
                    <el-form-item :label="$t('miAgent.paperType')+ ':'" prop="paperType">
                        <el-select v-model="twoInfo.paperType"  style="width: 300px">
                            <el-option v-for="item in paperTypeList" :key="item.code" :label="$t(item.title)" :value="item.code"/>
                        </el-select>
                    </el-form-item>
                    <!-- 证件号 -->
                    <el-form-item :label="$t('miAgent.paperNo')+ ':'" prop="paperNo">
                        <el-input v-model.trim="twoInfo.paperNo" clearable  style="width: 300px"/>
                    </el-form-item>
                    <!--联系资料-->
                    <div class="pane-title">{{ $t('mi.lable.contact.info') }}</div>
                    <el-divider/>
                    <!-- 所在地区 -->
                    <el-form-item :label="$t('miAgent.regionCode')+ ':'" required>
                        <AddrSelect :addr-info="AddrInfo" @provinceEmit="getProvinceId"  />
                    </el-form-item>
                    <!--详细地址-->
                    <el-form-item :label="$t('miAgent.storeAddr')+ ':'" prop="storeAddr">
                        <el-input v-model="twoInfo.storeAddr" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--移动电话-->
                    <el-form-item :label="$t('miAgent.mobile')+ ':'" prop="mobile">
                        <el-input v-model="twoInfo.mobile" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--电子邮件-->
                    <el-form-item :label="$t('sysUser.email')+ ':'" prop="email">
                        <el-input v-model.trim="twoInfo.email" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--邮政编码-->
                    <el-form-item :label="$t('miAgent.storePost')+ ':'">
                        <el-input v-model.trim="twoInfo.storePost" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--传真-->
                    <el-form-item :label="$t('biVendor.fax')+ ':'">
                        <el-input v-model.trim="twoInfo.fax" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--银行账户信息-->
                    <div class="pane-title">{{ $t('miAgent.title.accountInfo') }}</div>
                    <el-divider/>
                    <!--开户银行-->
                    <el-form-item :label="$t('miAgent.accountBank')+ ':'" prop="accountBank">
                        <el-input v-model.trim="twoInfo.accountBank"  placeholder="" clearable style="width: 300px" />
                    </el-form-item>
                    <!--户名-->
                    <el-form-item  :label="$t('miAgent.accountName')+ ':'" prop="accountName">
                        <el-input v-model="twoInfo.accountName" disabled class="inputw" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--帐号-->
                    <el-form-item :label="$t('fiBank.bankAccount')+ ':'" prop="accountCode">
                        <el-input v-model.trim="twoInfo.accountCode" readonly onfocus="this.removeAttribute('readonly')" style="width: 300px" placeholder=""/>
                    </el-form-item>
                    <!--密码设置-->
                    <div class="pane-title">{{ $t('miAgent.title.LoginInfo') }}</div>
                    <el-alert
                      title="The default transaction password is the same as this login password.Please login and change"
                      type="warning">
                    </el-alert>
                    <el-divider/>
                    <!-- 登录密码 -->
                    <el-form-item :label="$t('sysUser.userPassword')+ ':'" prop="tmpPassword">
                        <el-input v-model.trim="twoInfo.tmpPassword" clearable style="width: 300px" show-password />
                        <span style="color: red;margin-left: 5px">  Require 8 to 16 digits with letters or munber or both</span>
                    </el-form-item>
                    <!-- 重复密码 -->
                    <el-form-item :label="$t('sysUser.repeatPassword')+ ':'" prop="tmpRePassword">
                        <el-input v-model.trim="twoInfo.tmpRePassword" clearable style="width: 300px" show-password/>
                    </el-form-item>
                </el-form>
                <el-divider/>
                <div style="text-align: center;margin: 20px 0 40px">
                    <el-button icon="el-icon-back" @click="goStep1">{{ $t('button.previous') }}</el-button>
                    <el-button :loading="doLoading" type="primary" icon="el-icon-right" @click="goStep3">{{ $t('button.next') }}</el-button>
                    <el-button type="default" icon="el-icon-close" @click="onBack">{{ $t('operation.button.cancel') }}</el-button>
                </div>
            </div>
            <div v-show="step===3">
                <el-form label-width="160px" size="mini">
                    <div class="pane-title">{{ $t('Common.basicInfomation') }}</div>
                    <el-divider/>
                    <!-- 推荐人编号 -->
                    <el-form-item :label="$t('mi.recommendNo')+ ':'">
                        {{ oneInfo.recommendNo }}
                    </el-form-item>
                    <!-- 安置人编号 -->
                    <el-form-item :label="$t('mi.linkNo')+ ':'">
                        {{ oneInfo.tmpLinkNo }}
                    </el-form-item>
                    <!-- 代办处编号 -->
                    <el-form-item :label="$t('miAgent.agentNo')+ ':'">
                        {{ oneInfo.agentNo }}
                    </el-form-item>
                    <!-- 经销商编号 -->
                    <el-form-item :label="$t('miMember.memberNo')+ ':'" >
                        {{ oneInfo.memberNo }}
                    </el-form-item>
                    <!-- 经销商姓名 -->
                    <el-form-item :label="$t('miMember.name')+ ':'">
                        {{ twoInfo.name }}
                    </el-form-item>
                    <!-- 分公司编码 -->
                    <el-form-item :label="$t('fiAwardTemp.companyCode')+ ':'">
                        {{ twoInfo.companyCode }}
                    </el-form-item>
                    <!-- 证件类型 -->
                    <el-form-item :label="$t('miAgent.paperType')+ ':'">
                        {{ $lt(initDict.paperType, twoInfo.paperType) }}
                    </el-form-item>
                    <!-- 证件号 -->
                    <el-form-item :label="$t('miAgent.paperNo')+ ':'">
                        {{ twoInfo.paperNo }}
                    </el-form-item>
                    <!--收货信息-->
                    <div class="pane-title">{{ $t('register.us.legend.shipping') }}</div>
                    <el-divider/>
                    <!--所在地区-->
                    <el-form-item :label="$t('miAgent.regionCode')+ ':'">
                        {{selectAddr.country}} {{selectAddr.province}}
                    </el-form-item>
                    <!--详细地址-->
                    <el-form-item :label="$t('miAgent.storeAddr')+ ':'">
                        {{ twoInfo.storeAddr }}
                    </el-form-item>
                    <!--移动电话-->
                    <el-form-item :label="$t('miAgent.mobile')+ ':'">
                        {{ twoInfo.mobile }}
                    </el-form-item>
                    <!--电子邮件-->
                    <el-form-item :label="$t('sysUser.email')+ ':'">
                        {{ twoInfo.email }}
                    </el-form-item>
                    <!--邮政编码-->
                    <el-form-item :label="$t('miAgent.storePost')+ ':'">
                        {{ twoInfo.storePost }}
                    </el-form-item>
                    <!--传真-->
                    <el-form-item :label="$t('biVendor.fax')+ ':'">
                        {{ twoInfo.storePost }}
                    </el-form-item>
                    <!--银行账户信息-->
                    <div class="pane-title">{{ $t('miAgent.title.accountInfo') }}</div>
                    <el-divider/>
                    <!--开户银行-->
                    <el-form-item :label="$t('miAgent.accountBank')+ ':'">
                        {{ twoInfo.accountBank }}
                    </el-form-item>
                    <!--户名-->
                    <el-form-item :label="$t('miAgent.accountName')+ ':'">
                        {{ twoInfo.accountName }}
                    </el-form-item>
                    <!--帐号-->
                    <el-form-item :label="$t('fiBank.bankAccount')+ ':'">
                        {{ twoInfo.accountCode }}
                    </el-form-item>
                </el-form>
                <el-divider/>
                <div style="text-align: center;margin: 20px 0 40px">
                    <el-button icon="el-icon-back" @click="goStep2">{{ $t('button.previous') }}</el-button>
                    <el-button :loading="doLoading" type="primary" icon="el-icon-right" @click="saveData">{{ $t('title.submit') }}</el-button>
                    <el-button type="default" icon="el-icon-close" @click="onBack">{{ $t('operation.button.cancel') }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import i18n from '@/lang'
    import {getLanguage} from '@/lang'
    import {
        checkRegisterInfo,
        checkRightInfo,
        getMiMemberInfo,
        saveRegisterInfo,
        getMiAgentInfo
    } from "@/api/home"
    import {registerGetMemberNo} from "@/api/member";
    import AddrSelect from "@/components/AddrSelect.vue";
    import {mapGetters} from "vuex";
    export default {
        name: 'InRegister',
        components: { AddrSelect },
        data() {
            return {
                selectAddr: {
                    country: "",
                    province: ""
                },
                AddrInfo: [],
                step: 1,
                localLanguage: '',
                doLoading: false,
                recommendName: '',
                tmpLinkNo: '',
                agentNo: '',
                agentCompanyCode: null,
                colorSpan0: '',
                colorSpan1: '',
                colorSpan2: '',
                oneInfo: {
                    recommendNo: '',
                    tmpLinkNo: '',
                    agentNo: '',
                    agentNoCompany: ''
                },
                regionLoading: false,
                twoInfo: {
                  companyCode: null
                },
                initDict: {
                    cnMemberLevel: 'cn.member.level', // 经销商级别
                    cnMimemberCardtype: 'cn.mimember.cardtype', // 荣衔
                    companyCode: 'Not_have.point.register', // 分公司可选列表
                    paperType: 'miagent.papertype', // 证件类型
                },
                oneRules: {
                    recommendNo: [{required: true, message: '', trigger: ['blur', 'change']}],
                    tmpLinkNo: [{required: true, message: '', trigger: ['blur', 'change']}],
                    agentNo: [{required: true, message: '', trigger: ['blur', 'change']}]
                },
                twoRules: {
                    name: [{required: true, message: '', trigger: ['blur', 'change']}],
                    companyCode: [{required: true, message: '', trigger: ['blur', 'change']}],
                    paperType: [{required: true, message: '', trigger: ['blur', 'change']}],
                    paperNo: [{required: true, message: '', trigger: ['blur', 'change']}],
                    storeAddr: [{required: true, message: '', trigger: ['blur', 'change']}],
                    mobile: [{required: true, message: '', trigger: ['blur', 'change']}],
                    email: [{required: true, message: '', trigger: ['blur', 'change']}],
                    accountBank: [{required: true, message: '', trigger: ['blur', 'change']}],
                    accountName: [{required: true, message: '', trigger: ['blur', 'change']}],
                    accountCode: [{required: true, message: '', trigger: ['blur', 'change']}],
                    tmpPassword: [{required: true, message: '', trigger: ['blur', 'change']}],
                    tmpRePassword: [{required: true, message: '', trigger: ['blur', 'change']}],
                }
            }
        },
        computed: {
            ...mapGetters([
                'userCode',
                'companyCode',
        ]),
            companyCodeList() {
              if(this.companyCode) {
                return this.$ll(this.initDict.companyCode).filter(item=> item.code === this.companyCode)
              } else if (this.agentCompanyCode){
                return this.$ll(this.initDict.companyCode).filter(item=> item.code === this.agentCompanyCode)
              } else {
                return this.$ll(this.initDict.companyCode)
              }
            },
            paperTypeList() {
                return this.$ll(this.initDict.paperType)
            }
        },
        async created() {
            if (!this.userCode) {
                this.localLanguage = this.$route.query.language.toString()
                this.$i18n.locale = this.$route.query.language.toString()
                await getLanguage()
            }
            if(this.companyCode) {
              this.twoInfo.companyCode = this.companyCode
            }
        },
        mounted() {
            if (this.userCode) {
                setTimeout(() => {
                    this.oneRules.recommendNo[0].message = this.$t('label.pleaseFillIn')
                    this.oneRules.tmpLinkNo[0].message = this.$t('label.pleaseFillIn')
                    this.oneRules.agentNo[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.name[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.companyCode[0].message = this.$t('poOrder.pleaseChoose')
                    this.twoRules.paperType[0].message = this.$t('poOrder.pleaseChoose')
                    this.twoRules.paperNo[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.storeAddr[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.mobile[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.email[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.accountBank[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.accountName[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.accountCode[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.tmpPassword[0].message = this.$t('label.pleaseFillIn')
                    this.twoRules.tmpRePassword[0].message = this.$t('label.pleaseFillIn')
                }, 1000)
            } else {
                setTimeout(() => {
                    this.oneRules.recommendNo[0].message = i18n.t('label.pleaseFillIn')
                    this.oneRules.tmpLinkNo[0].message = i18n.t('label.pleaseFillIn')
                    this.oneRules.agentNo[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.name[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.companyCode[0].message = i18n.t('poOrder.pleaseChoose')
                    this.twoRules.paperType[0].message = i18n.t('poOrder.pleaseChoose')
                    this.twoRules.paperNo[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.storeAddr[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.mobile[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.email[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.accountBank[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.accountName[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.accountCode[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.tmpPassword[0].message = i18n.t('label.pleaseFillIn')
                    this.twoRules.tmpRePassword[0].message = i18n.t('label.pleaseFillIn')
                }, 1000)
            }
        },
        methods: {
            getProvinceId(val) {
                this.selectAddr = val
                this.twoInfo.regionCode = val ? val.id : ''
            },
            // 取消
            onBack() {
                this.$router.go(-1)
            },
            // ++++++++++++++++++++++ step === 1 ++++++++++++++++++++++++
            // 推荐人编号获取信息
            recommendNoBlur(val) {
                if (val) {
                    getMiMemberInfo({memberNo: val.trim().toUpperCase()}).then(res => {
                        if (res.data.memberNo) {
                            this.colorSpan0 = res.data.levelType === '0' ? 'red-span' : 'yellow-span'
                            this.recommendName = res.data.name ? res.data.name+'/'+this.$lt(this.initDict.cnMemberLevel,res.data.levelType)+(res.data.cardType>=2 ? '/'+this.$lt(this.initDict.cnMimemberCardtype,res.data.cardType) : '') : ''
                            this.oneInfo.agentNo = res.data.agentNo ? res.data.agentNo : ''
                            this.oneInfo.agentNoCompany = res.data.companyCode ? res.data.companyCode : ''
                            this.agentBlur(this.oneInfo.agentNo)
                        } else {
                            this.colorSpan0 = 'red-span'
                            this.recommendName = this.$t('busi.not.exist')  // 不存在
                        }
                    }).catch(() => {
                        this.recommendName = ''
                        this.oneInfo.agentNo = ''
                        this.oneInfo.agentNoCompany = ''
                    })
                } else {
                    this.recommendName = ''
                    this.oneInfo.agentNo = ''
                    this.oneInfo.agentNoCompany = ''
                }
            },
            // 安置人编号获取信息
            tmpLinkNoBlur(val) {
                if (val) {
                    getMiMemberInfo({memberNo: val.trim().toUpperCase()}).then(res => {
                        if (res.data.memberNo) {
                            this.colorSpan1 = res.data.levelType === '0' ? 'red-span' : 'yellow-span'
                            this.tmpLinkNo = res.data.name ? res.data.name+'/'+this.$lt(this.initDict.cnMemberLevel,res.data.levelType)+(res.data.cardType>=2 ? '/'+this.$lt(this.initDict.cnMimemberCardtype,res.data.cardType) : '') : ''
                        } else {
                            this.colorSpan1 = 'red-span'
                            this.tmpLinkNo = this.$t('busi.not.exist')  // 不存在
                        }
                    }).catch(() => {
                        this.tmpLinkNo = ''
                    })
                } else {
                    this.tmpLinkNo = ''
                }
            },
            // 代办处编号
            async agentBlur(val) {
                if (val) {
                    await  getMiAgentInfo({agentNo: val.trim().toUpperCase(), companyCode: this.oneInfo.agentNoCompany }).then(res => {
                        if (res.data.agentNo) {
                            this.colorSpan2 = 'green-span'
                            this.agentNo = res.data.name
                            this.agentCompanyCode = res.data.companyCode
                        } else {
                            this.colorSpan2 = 'red-span'
                            this.agentNo = this.$t('busi.not.exist')  // 不存在
                            this.agentCompanyCode = null
                        }
                    }).catch(() => {
                        this.colorSpan2 = 'red-span'
                        this.agentNo = ''
                        this.agentCompanyCode = null
                    })
                } else {
                    this.colorSpan2 = 'red-span'
                    this.agentNo = ''
                    this.agentCompanyCode = null
                }
            },
            // 下一步
            nextBtn() {
                this.$refs['oneRef'].validate((valid) => {
                    if (valid) {
                        this.doLoading = true
                        checkRightInfo({...this.oneInfo}).then(() => {
                            registerGetMemberNo({ 'agentNo': this.oneInfo.agentNo }).then(res => {
                                this.oneInfo.memberNo = res.data
                                this.step = 2
                                this.doLoading = false
                            }).catch(() => {
                                this.doLoading = false
                            })
                        }).catch(() => {
                            this.doLoading = false
                        })
                    }
                })
            },
            // ++++++++++++++++++++++ step === 2 ++++++++++++++++++++++++
            // 返回到第一步
            goStep1() {
                this.step = 1
            },
            nameBlur(val) {
                if (val.target.value) {
                    this.twoInfo.accountName = val.target.value
                }
            },
            goStep3() {
                this.$refs['twoRef'].validate((valid) => {
                    if (valid) {
                        this.doLoading = true
                        // if (!this.twoInfo.regionCode) {
                        //     this.$message.error(this.$t('poOrder.pleaseChoose') + this.$t('miAgent.regionCode')) // 请选择所在地区
                        //     this.doLoading = false
                        //     return false
                        // }
                        if (this.twoInfo.tmpPassword === this.twoInfo.tmpRePassword) {
                            this.twoInfo.tmpPayPassword = this.twoInfo.tmpPassword
                            this.twoInfo.tmpRePayPassword = this.twoInfo.tmpPassword
                        } else {
                            this.twoInfo.tmpPayPassword = ''
                            this.twoInfo.tmpRePayPassword = ''
                            this.doLoading = false
                            this.$message.error(this.$t('error.password.not.accord')) // 两次输入的密码不一致,请重新输入并确认
                        }
                        checkRegisterInfo({...this.oneInfo, ...this.twoInfo}).then(res => {
                            res.success ? this.step = 3 : ''
                            this.doLoading = false
                        }).catch(() => {
                            this.doLoading = false
                        })
                    }
                })
            },
            // ++++++++++++++++++++++ step === 3 ++++++++++++++++++++++++
            // 返回到第二步
            goStep2() {
                this.step = 2
            },
            saveData() {
                this.$confirm(this.$t('fi.sure.handle').toString(), ' ', {
                    confirmButtonText: this.$t('button.confirm'),
                    cancelButtonText: this.$t('operation.button.cancel'),
                    type: 'success'
                }).then(() => {
                    this.doLoading = true
                    // 注册经销商
                    saveRegisterInfo({...this.oneInfo, ...this.twoInfo}).then(res => {
                        if (res.success) {
                            this.$notify({
                                title: this.$t('Common.success'),
                                message: this.$t('success.operation'),
                                type: 'success',
                                duration: 2000
                            })
                            this.$router.push({
                                path: '/inRegisterSuccess',
                                query: {language: this.localLanguage, memberNo: res.data}
                            })
                        } else {
                            this.$message.error(this.$t('mi.register.fail'))
                        }
                        this.doLoading = false
                    }).catch(() => {
                        this.doLoading = false
                    })
                }).catch(() => {
                    this.doLoading = false
                })
            }
        }
    }

</script>

<style scoped lang="scss">
    .inputw {
        ::v-deep .el-input__inner {
            color: black;
            background-color: white;
        }
    }
    .red-span {
        color: red;
    }

    .green-span {
        color: green;
    }
    .yellow-span {
        color: #F39F43;
    }
</style>
